The date & time the hirer relationship was changed.

This field has weak ordering guarantees, so it should not be used as a pagination argument.
